import { render, staticRenderFns } from "./DelayedTransferSummary.vue?vue&type=template&id=112556d6&scoped=true"
import script from "./DelayedTransferSummary.vue?vue&type=script&lang=js"
export * from "./DelayedTransferSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112556d6",
  null
  
)

export default component.exports